import { LatLngAlt } from "../../../types.js";

export const edgeNeokyoF1: LatLngAlt[] = [
  [-10.791534, 165.843601, 66],
  [-10.79155, 165.843698, 66],
  [-10.791562, 165.843784, 66],
  [-10.791572, 165.843891, 66],
  [-10.79158, 165.843987, 66],
];
export const edgeNeokyoF2: LatLngAlt[] = [
  [-10.791558, 165.843902, 66],
  [-10.791446, 165.843827, 66],
  [-10.791314, 165.843816, 66],
];
export const edgeNeokyoF3: LatLngAlt[] = [
  [-10.791379, 165.843848, 66],
  [-10.791501, 165.843773, 66],
  [-10.791557, 165.843633, 66],
];
